import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Modal, FormControlLabel, Checkbox, useMediaQuery, IconButton, Grid, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CrossIcon from '../assests/croosicon.png';
import { styled } from '@mui/material/styles';
import CloseEyeIcon from '../../common/assests/eclose.svg';
import OpenEyeIcon from '../../common/assests/eopen.svg';
import { toast } from 'react-toastify';
// Styled Checkbox component
const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  '& .MuiCheckbox-root': {
    color: '#065F46',
  },
  '& .Mui-checked': {
    color: '#065F46',
  },
}));

const permissions = [
  "Dashboard",
  "User Management",
  "Vendor Management",
  "Orders",
  "Content Management",
  "Reports & Analysis",
  "Event Management",
  "Push Notification",
  "Help & Support"
];


const UserPermissionModal = ({ open, onClose, onSave }) => {
  const isSmallScreen = useMediaQuery('(max-width:576px)');
  const gridSpacing = isSmallScreen ? 1 : 2; 

  // State to manage user input and permissions
  const [userData, setUserData] = useState({
    userName: '',
    email: '',
    mobile: '',
    password: '',
    retypePassword: '',
    permissions: Array(permissions.length).fill(false) || [], 
  });

  // Handle checkbox change
  const handleCheckboxChange = (index) => {
    setUserData((prevData) => {
      const updatedPermissions = [...prevData.permissions];
      updatedPermissions[index] = !updatedPermissions[index];
      return { ...prevData, permissions: updatedPermissions };
    });
  };

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  // Handle input field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "mobile") {
      if (/^\d{0,10}$/.test(value)) {
        setUserData((prevData) => ({ ...prevData, [name]: value }));
      }
    } else {
      if (value.trim() !== "" || value === "") {
        setUserData((prevData) => ({ ...prevData, [name]: value }));
      }
    }
  };
  
  // Handle form submit
  // const handleSave = () => {
  //   const newAdminData = {
  //     username: userData.userName,
  //     email: userData.email,
  //     phone: userData.mobile,
  //     password: userData.password,
  //     retypePassword: userData.retypePassword,
  //     permissions: userData.permissions, 
  //   };
  //   onSave(newAdminData);
  //   onClose(); 
  // };

  const handleSave = () => {
    const hasPermissionSelected = userData.permissions.some((perm) => perm);
    const passwordsMatch = userData.password === userData.retypePassword;
    const isPasswordLongEnough = userData.password.length >= 8;
  
  
    if (!userData.userName || !userData.email || !userData.mobile) {
      toast.warning("All fields are required!");
      return; 
    }
    if (userData.mobile.length !== 10) {
      toast.error("Mobile number must be  10 digits!");
      return;
    }
   
    if (!validateEmail(userData.email)) {
      toast.error("Please provide a valid email address.");
      return; 
    }
  

    if (!passwordsMatch) {
      toast.error('Passwords do not match!');
      return; 
    }

    if (!isPasswordLongEnough) {
      toast.error('Password must be at least 8 characters long!');
      return; 
    }
  
   
    if (!hasPermissionSelected) {
      toast.error('At least one permission must be selected!');
      return;
    }
  
 
    const newAdminData = {
      username: userData.userName,
      email: userData.email,
      phone: userData.mobile,
      password: userData.password,
      retypePassword: userData.retypePassword,
      permissions: userData.permissions,
    };
  
    onSave(newAdminData);

    setUserData({
      userName: '',
      email: '',
      mobile: '',
      password: '',
      retypePassword: '',
      permissions: Array(permissions.length).fill(false),
    });
  
    onClose();

  };

  useEffect(() => {
    
    if (!open) {
      setShowPasswords({
        newPassword: false,
        confirmNewPassword: false,
      });
    }
  }, [open]);
  

  
  const [showPasswords, setShowPasswords] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });

  const handleClickShowPassword = (field) => {
    setShowPasswords((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };



  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isSmallScreen ? '94%' : '540px',
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography id="modal-title" sx={{ fontSize: '20px', color: '#362B24', fontWeight: '700' }}>
            Add New Permission
          </Typography>
          <IconButton onClick={onClose}>
            <img src={CrossIcon} alt="Close" style={{ height: '20px', width: '20px' }} />
          </IconButton>
        </Box>

        {/* User Name Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '25px' }}>
          User Name
        </Typography>
        <TextField
          fullWidth
          name="userName"
          value={userData.userName}
          onChange={handleInputChange}
          placeholder="Type user name"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Email Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Email
        </Typography>
        <TextField
          fullWidth
          name="email"
          type="email"
          value={userData.email}
          onChange={handleInputChange}
          placeholder="Type your email"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Mobile Number Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Mobile Number
        </Typography>
        <TextField
          fullWidth
          name="mobile"
          type="text"
          value={userData.mobile}
          onChange={handleInputChange}
          placeholder="Type your mobile number"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Password Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Password
        </Typography>
        <TextField
          fullWidth
          name="password"
          type={showPasswords.newPassword ? 'text' : 'password'} 
          value={userData.password}
          onChange={handleInputChange}
          placeholder="Type your password"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img
                  src={showPasswords.newPassword ? OpenEyeIcon : CloseEyeIcon}
                  alt="toggle-password-visibility"
                  onClick={() => handleClickShowPassword('newPassword')}
                  className="toggle-password-icon"
                />
              </InputAdornment>
            ),
          }}
        />

        {/* Retype Password Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Retype Password
        </Typography>
        <TextField
          fullWidth
          name="retypePassword"
          type={showPasswords.confirmNewPassword ? 'text' : 'password'} 
          value={userData.retypePassword}
          onChange={handleInputChange}
          placeholder="Retype your password"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img
                  src={showPasswords.confirmNewPassword ? OpenEyeIcon : CloseEyeIcon}
                  alt="toggle-password-visibility"
                  onClick={() => handleClickShowPassword('confirmNewPassword')}
                  className="toggle-password-icon"
                />
              </InputAdornment>
            ),
          }}
        />

        {/* User Permissions */}
        <Typography sx={{ marginTop: '20px', marginBottom: '10px', fontSize: '17px', fontWeight: '600', marginLeft: '10px' }}>
          User Permissions
        </Typography>
        <Grid container spacing={gridSpacing}>
        {permissions.map((permission, index) => (
          <Grid item xs={6}  sm={4} key={index}>
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={userData.permissions?.[index] || false} 
                  onChange={() => handleCheckboxChange(index)}
                />
              }
              label={permission}
            />
          </Grid>
        ))}
      </Grid>

        {/* Save Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center',}} mt={2}>
          <Button
            sx={{
              mt: 2,
              width: '323px',
              height: '57px',
              borderRadius: '28.5px',
              background: 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)',
              color: 'white',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={handleSave}
          >
            Add User
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UserPermissionModal;
